<template>
    <div class="layout-advanced-search-box">
        <div class="layout-asb-title dsp-flex" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
            <div class="layout-asb-item" v-for="string in stringArr">
                <span>{{string}}柱</span>
            </div>
        </div>
        <div class="layout-asb-list dsp-flex">
            <div class="layout-asb-item" v-for="arr in searchChooseBoxList" :key="'box'+arr[0]['type']">
                <div class="layout-asb-box" v-for="data in arr" :key="data.type" @click="clickSearchItem(data)" v-bind:class="{'colume-item-gray': parseInt(settingConfigData.showColor) == 0}">
                    <i v-if="!data.choosedData.text" class="iconfont icon-wenhao layout-asb-icon"></i>
                    <span v-else class="layout-asb-word" v-bind:class="'wd-' + data.choosedData.propXingEn">{{data.choosedData.text}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DOM, SEARCH_DOM } from '../../modules/dom';
export default {
    name: 'AdvancedSearchBox',
    data() {
        return {
            stringArr: ['年', '月', '日', '时'],
            itemSize: {width: 0, height: 0},
            basicPos: {x: 0, y: 0}  //第一个item的值，用来计算点击item的pos值，以确定三角形的定位
        }
    },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        searchChooseBoxList() {
            var searchChooseBoxList = [].concat(this.$store.state.search.searchChooseBoxList);
                searchChooseBoxList = parseInt(this.$store.state.setting.settingConfigData.nianyueRishi) == 0 ? searchChooseBoxList : searchChooseBoxList.reverse();
            return searchChooseBoxList;
        }
    },
    mounted: function() {        
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 10);
    },
    methods: {
        initDom() {
            var topDiv = document.getElementsByClassName('search-title-bar')[0];
            var titleDiv = document.getElementsByClassName('layout-asb-title')[0];
            var itemBoxDiv = document.getElementsByClassName('layout-asb-item')[0];
            var itemDiv = document.getElementsByClassName('layout-asb-box')[0];

            // 获取基础的定位值
            var x = parseInt(itemBoxDiv.clientWidth / 2) - 6 , y = topDiv.clientHeight + titleDiv.clientHeight + itemDiv.clientHeight + 20;
            this.$set(this.basicPos, 'x', x);
            this.$set(this.basicPos, 'y', y);
            this.$set(this.itemSize, 'width', itemBoxDiv.clientWidth);
            this.$set(this.itemSize, 'height', (itemDiv.clientHeight + 20));
            // console.log('AdvancedSearchBox-------mounted', this.basicPos, this.itemSize);
        },
        clickSearchItem(data) {
            this.$store.dispatch('search/updateSearchChooseData', data);
            this.$store.state.search.showChooseItemPop = true;
            var me = this,
                nyrs = parseInt(this.settingConfigData.nianyueRishi),
                newPos = nyrs == 1 ? [3-data.pos[0], data.pos[1]] : data.pos;
            setTimeout(() => {
                DOM.updateChooseItemPopPos(newPos, me.basicPos, me.itemSize);
            }, 0);
            setTimeout(() => {
                SEARCH_DOM.updateAdvancedSearchPageStyle();
            }, 20);
        }
    }
}
</script>